import './navigation_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['filters', 'menuToggle', 'query', 'choices', 'slider', 'form']

  controllers = (identifier: string, things: HTMLElement[]): object[] => {
    const instances = []

    for (const thing of things) {
      instances.push(this.application.getControllerForElementAndIdentifier(thing, identifier))
    }

    return instances
  }

  get filtersController (): object {
    return this.application.getControllerForElementAndIdentifier(this.filtersTarget, 'filters')
  }

  get queryController (): object {
    return this.application.getControllerForElementAndIdentifier(this.queryTarget, 'query')
  }

  get menuToggleControllers (): object[] {
    return this.controllers('menu-toggle', this.menuToggleTargets)
  }

  get choicesControllers (): object[] {
    return this.controllers('choices', this.choicesTargets)
  }

  get sliderControllers (): object[] {
    return this.controllers('slider', this.sliderTargets)
  }

  submitForm = (): void => {
    this.appendQueryParamsToForm()
    this.formTarget.submit()
  }

  clearQueryParams = (): void => {
    const urlWithoutQueryParams = window.location.origin + window.location.pathname
    history.replaceState({}, document.title, urlWithoutQueryParams)
  }

  appendQueryParamsToForm = (): void => {
    const baseUrl = window.location.origin + window.location.pathname

    const urlParams = new URLSearchParams(window.location.search)
    const formAction = new URL(baseUrl)
    urlParams.forEach((value, key) => {
      formAction.searchParams.set(key, value)
      if (
        key === 'dynamic_attributes[order_by_item_id]' ||
        key === 'dynamic_attributes[order]'
      ) {
        this.appendInputToForm(key, value)
      }
    })
    this.formTarget.action = formAction.toString()
  }

  appendInputToForm = (name: string, value: string): void => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    this.formTarget.appendChild(input)
  }
}
